import { useContext } from "react";

import { Box, Container, VStack, Text, Button } from "@chakra-ui/react";

import { PageContext } from "mlp-sdk";

import { trackEvent } from "mlp-sdk/utils/firebase";

import { LP_DOCS_KNOW_MORE } from "mlp-sdk/constants/firebase";

const Banner = () => {
  const { page } = useContext(PageContext);
  const { section_details } = page?.data?.pageData || {};

  return (
    <Box
      mt={{ base: "58px", lg: "74px" }}
      w="100vw"
      h={{ base: "368px", lg: "525px" }}
    >
      <Container
        display="flex"
        h="full"
        py="0"
        justifyContent="center"
        textAlign="center"
      >
        <VStack justify="center" gap="2rem">
          <Box>
            {section_details?.title && (
              <Text
                textStyle={{ base: "h2", lg: "h1" }}
                fontSize={{ base: 32, lg: 64 }}
              >
                {section_details.title}
              </Text>
            )}

            {section_details?.sub_title && (
              <Text
                maxW={{ base: "328px", md: "583px" }}
                mt={6}
                textStyle={{ base: "p12", lg: "p16" }}
                fontWeight={500}
                color="textSecondary"
              >
                {section_details.sub_title}
              </Text>
            )}
          </Box>

          {section_details?.cta_text && (
            <Button
              p="1rem 4rem"
              h="56px"
              w={{ base: "210px", lg: "212px" }}
              bg="accent"
              _hover={{
                bg: "primary",
              }}
              as="a"
              href={section_details?.cta_link}
              target="_blank"
              onClick={() => {
                trackEvent(LP_DOCS_KNOW_MORE, {
                  cta_text: section_details?.cta_text,
                  cta_link: section_details?.cta_link,
                });
              }}
            >
              {section_details?.cta_text}
            </Button>
          )}
        </VStack>
      </Container>
    </Box>
  );
};

export default Banner;
